export const template = [
  { id: 'test_type', header: 'searchReport.dataResult.test_type_doc' },
  { id: 'test_name', header: 'searchReport.dataResult.test_name' },
  { id: 'order_item', header: 'searchReport.dataResult.order_item', width: '150px' },
  { id: 'code', header: 'searchReport.dataResult.code' },
  { id: 'action', header: 'searchReport.dataResult.status' },
  { id: 'analyst_name', header: 'searchReport.dataResult.analyst_name' },
  { id: 'started_on', header: 'searchReport.dataResult.started_on' },
  { id: 'checker_name', header: 'searchReport.dataResult.checker_name' },
  { id: 'checked_date', header: 'searchReport.dataResult.checked_started_on', width: '150px' },
  { id: 'approver_name', header: 'searchReport.dataResult.approver_name' },
  {
    id: 'approval_date',
    header: 'searchReport.dataResult.approval_started_on', width: '150px',
  },
  { id: 'publisher_name', header: 'searchReport.dataResult.publisher_name' },
  {
    id: 'published_date',
    header: 'searchReport.dataResult.published_started_on', width: '150px',
  },
  { id: 'started_on_step', header: 'searchReport.dataResult.action_on', width: '200px' },
  { id: 'comment', header: 'searchReport.dataResult.comment' },
  { id: 'column_report', header: ' ' },
]
